import { render, staticRenderFns } from "./weight_loss_camp.vue?vue&type=template&id=677529ff&scoped=true&"
import script from "./weight_loss_camp.vue?vue&type=script&lang=js&"
export * from "./weight_loss_camp.vue?vue&type=script&lang=js&"
import style0 from "./weight_loss_camp.vue?vue&type=style&index=0&id=677529ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677529ff",
  null
  
)

export default component.exports